import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	by: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.by',
		defaultMessage: 'By {authorLabel}',
		description: 'indicate the author of the gadget',
	},
	addThisGadget: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.add-this-gadget',
		defaultMessage: 'Add',
		description: 'The label on a button, click button to add this gadget to dashboard',
	},
	addButtonlabel: {
		id: 'dashboard-edit.header-editable.add-gadget-button.add-gadget-panel.gadget-directory-item.add-buttonlabel',
		defaultMessage: 'Add {title}',
		description: 'Aria-label for add this gadget to dashboard button',
	},
});
